/**
 * ModuleIcon — Renders a module's lucide icon with its color.
 *
 * Falls back to Package icon if the icon name is not found.
 */
import { Package } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { getIconComponent } from '../../../shared/config/iconMap';

interface ModuleIconProps {
  /** Lucide icon name (e.g., "Blocks", "Globe") */
  iconName: string | null | undefined;
  /** Hex color for the icon */
  color?: string | null;
  /** Tailwind size classes (default: "h-4 w-4") */
  className?: string;
}

export function ModuleIcon({ iconName, color, className = 'h-4 w-4' }: ModuleIconProps) {
  const IconComponent = getIconComponent(iconName ?? undefined) ?? Package;
  return (
    <IconComponent
      className={cn(className, 'shrink-0')}
      style={color ? { color } : undefined}
    />
  );
}
